import React from "react";
import "../style/StyleForComponents.css";

const MainContent = () => {
  return (
    <div className="MainContent" id="MainContent">
      <div className="section section1">
        <h1>МЕРЕЖА ФІТНЕС-КЛУБІВ В КИЄВІ</h1>
        <div className="first_red">Спорт простір на Хрещатику</div>
        <div className="second_red">Київ, вул. Крещатик 106</div>
        <div className="first_red">Спорт простір на Лівобережній</div>
        <div className="second_red">Київ, вул. Каховська 60</div>
      </div>
    </div>
  );
};

export default MainContent;
